import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Grid, List, ListItem } from '@mui/material';
import { withTranslation } from 'react-i18next';
import ReceiveMethodEnum from '../../enums/ReceiveMethodEnum';
import MenuItem from './MenuItem';
import CurrencyDisplay from '../common/CurrencyDisplay';

@inject('menuStore', 'cartStore', 'userStore', 'orderStore')
@observer
class MenuList extends Component {
  render() {
    const { t, menuStore, cartStore, userStore, orderStore } = this.props;
    return (
      <React.Fragment>
        <div className="order-detail-box">
          <div className="box-title">{t('menu.label.info')}</div>
          <div className="box-contents" style={{ paddingTop: 0 }}>
            <List className="menu-list">
              {cartStore.cartData.menus.map((cartMenu, index) => (
                <MenuItem cartMenu={cartMenu} key={index} />
              ))}
              {cartStore.cartData.receiveMethodCode === ReceiveMethodEnum.DELIVERY && (
                <ListItem className="menu-detail">
                  {/* 메뉴 */}
                  <Grid container>
                    <Grid item container direction="row">
                      <Grid
                        item
                        xs
                        display="flex"
                        style={{
                          alignItems: 'center',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          paddingRight: '5px',
                        }}
                      >
                        {t('order.label.DeliveryFee')}
                      </Grid>
                      <Grid item xs={4} style={{ fontSize: '12px', textAlign: 'right' }}>
                        <CurrencyDisplay amount={Number(menuStore.storeData.deliveryFee)} size="small" />
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              {orderStore.usePoint > 0 && userStore.userPoint >= menuStore.storeData.useableMinimumPoint && (
                <ListItem className="menu-detail">
                  {/* 메뉴 */}
                  <Grid container>
                    <Grid item container direction="row" gap={1} alignItems="center">
                      <Grid
                        item
                        xs
                        style={{
                          color: 'red',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          paddingRight: '5px',
                        }}
                      >
                        {t('payment.label.point')}
                      </Grid>
                      <Grid item style={{ width: '100px', textAlign: 'right', color: 'red' }}>
                        <CurrencyDisplay amount={Number(orderStore.usePoint)} size="small" minus />
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
              )}
            </List>
            <Grid container direction="row" style={{ paddingTop: '16px' }}>
              <Grid item xs>
                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t('payment.label.totalAmount')}</span>
              </Grid>
              <Grid item xs style={{ width: '92px', textAlign: 'right' }}>
                <CurrencyDisplay amount={orderStore.paymentAmount} type="emphasis" size="large" />
              </Grid>
            </Grid>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(MenuList));
